
import { Navbar, Nav, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/cannalogo3.png'
import { useNavigate } from 'react-router-dom';

export const NavbarComponent = () => {
	const navigate = useNavigate();
	return (
		<Navbar style={{
			backgroundColor: '#1a1a1a',
		}} collapseOnSelect expand="lg" fixed="top" >
			<Container >
				<Navbar.Brand onClick={
					() => {
						navigate('/')
					}
				}>
					<img src={logo} alt="logo" style={{ width: 'auto', height: '25px' }} />
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav">
					<FontAwesomeIcon icon={faBars} style={{ color: 'white' }} /> {/* Color can be adjusted */}
				</Navbar.Toggle>
				<Navbar.Collapse id="responsive-navbar-nav" s>
					<Nav className="ml-auto">
						<Nav.Link style={{
							color: '#ccc'
						}} href="#feature">Own a cannabis business?</Nav.Link>
						<Nav.Link style={{
							borderRadius: 5,
							background: '#039447',
							width: '130px',
							textAlign: 'center',
							color: 'white',
							fontFamily: 'carto-heavy'
						}} href={`https://calendly.com/jsena-za7j/canna42-app-demo`} target="_blank">REQUEST DEMO</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}
